module.exports = __webpack_public_path__ + "static/media/Icon_Warning.be34326b.svg";